import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbanialuxuryminibusonrent() {



  const cardData = {
"keyword": "Force Urbania Luxury Mini Bus On Rent",

"headingDescription":
  "Aaradhya Travels offers premium Force Urbania Luxury Mini Bus on Rent for corporate travel, airport transfers, weddings, family tours, pilgrimage trips, and outstation group journeys. Our Urbania fleet features ultra-comfortable reclining seats, powerful air-conditioning, premium interiors, ambient lighting, smooth suspension, and ample luggage space. With professional drivers and well-maintained vehicles, we ensure a safe, stylish, and luxury travel experience across Pune and Maharashtra.",

"topPlaces": [

  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort near Pune is a historic hill fort offering trekking routes and panoramic views of the Sahyadri mountains."
  },
    {
    "title": "Lavasa City",
    "description": "Lavasa is a planned hill city near Pune featuring lakeside views, colorful architecture, and a peaceful environment for short holidays."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is a major pilgrimage town near Pune dedicated to Sai Baba, attracting devotees throughout the year for spiritual visits."
  },
   {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill destination near Pune offering cool weather, strawberry farms, viewpoints, and refreshing monsoon scenery."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune known for vineyards, temples, and the sacred Trimbakeshwar Jyotirlinga shrine."
  },
   {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune known for scenic valleys, waterfalls, and weekend getaways, perfect for group and family trips."
  },
  {
    "title": "Karla Bhaja Caves",
    "description": "Karla and Bhaja Caves near Pune are ancient Buddhist rock-cut caves known for historical significance and architectural beauty."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake near Lonavala is a popular camping destination offering lakeside stays, bonfires, and adventure activities."
  },
  {
    "title": "Mumbai",
    "description": "Mumbai is a major metro city near Pune, popular for business trips, tourism, beaches, and weekend travel."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a scenic hill station close to Lonavala, famous for valleys, viewpoints, and monsoon landscapes."
  }
],



services: [
  {
    name: "Force Urbania Luxury Mini Bus on Rent Hadapsar",
    description: "Force Urbania luxury mini bus on rent Hadapsar service provides premium transportation for airport transfers, family vacations, wedding travel, corporate outings, and outstation journeys from Hadapsar Pune. Spacious luxury seating and modern interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "13 Seater Urbania Bus Hire in Kharadi",
    description: "13 seater Urbania bus hire in Kharadi service offers comfortable premium transportation for family tours, airport transfers, business travel, sightseeing trips, and outstation journeys from Kharadi Pune. Spacious seating and luggage capacity ensure pleasant travel experiences suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, homes, hotels, offices, and commercial locations across Kharadi Pune. Flexible booking options allow convenient 13 seater Urbania reservations."
  },
  {
    name: "17 Seater Urbania Bus Hire in Kharadi",
    description: "17 seater Urbania bus hire in Kharadi service provides luxurious transportation for corporate events, family vacations, educational tours, pilgrimage journeys, and tourist travel from Kharadi Pune. Spacious interiors and smooth highway performance ensure premium travel experiences suitable for larger passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, hotels, offices, and commercial areas across Kharadi Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "Luxury Bus for Corporate Events Online Booking",
    description: "Luxury bus for corporate events online booking service offers professional premium transportation for conferences, seminars, office meetings, employee travel, and executive business functions. Spacious luxury buses ensure comfortable travel experiences suitable for corporate teams and business passengers. Professional drivers ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient online luxury bus reservations."
  },
  {
    name: "Pune Airport Urbania Bus on Rent",
    description: "Pune Airport Urbania bus on rent service provides dependable premium transportation for tourists, wedding guests, business travelers, and family passengers arriving at Pune Airport. Spacious seating and luggage space ensure comfortable airport travel experiences suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport Urbania reservations."
  },
  {
    name: "Pune to Mumbai Airport Urbania Bus on Rent",
    description: "Pune to Mumbai Airport Urbania bus on rent service offers premium long-distance airport transportation for families, corporate groups, tourists, and wedding travel. Spacious interiors and luggage capacity ensure smooth expressway journeys suitable for airport transfer requirements. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and commercial locations across Pune. Flexible booking options allow convenient Mumbai Airport Urbania reservations."
  },
  {
    name: "Force Urbania Luxury Mini Bus on Rent for Outstation",
    description: "Force Urbania luxury mini bus on rent for outstation service provides stylish and comfortable long-distance transportation for Goa tours, Mahabaleshwar trips, pilgrimage journeys, and family vacations. Spacious luxury seating and smooth highway performance ensure pleasant travel experiences suitable for tourist and business groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Urbania Bus Hire in Hinjewadi",
    description: "Urbania bus hire in Hinjewadi service offers reliable premium transportation for IT professionals, office outings, airport transfers, educational tours, and family journeys from Hinjewadi Pune. Spacious seating and elegant interiors ensure smooth travel experiences suitable for business and leisure travel. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, homes, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Urbania Bus Hire in Aundh Baner",
    description: "Urbania bus hire in Aundh Baner service provides premium transportation for airport transfers, sightseeing trips, family vacations, business travel, and outstation journeys. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Aundh and Baner Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Urbania Bus on Rent for Pune to Shirdi Darshan",
    description: "Urbania bus on rent for Pune to Shirdi darshan service offers comfortable premium transportation for Sai Baba temple visits, pilgrimage journeys, family travel, and spiritual group tours from Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional drivers ensure safe transportation and reliable pickup services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi Urbania reservations."
  },
  {
    name: "Force Urbania on Rent in Pune Airport",
    description: "Force Urbania on rent in Pune Airport service provides luxurious airport transportation for tourists, corporate guests, wedding groups, and family passengers traveling to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely pickups and safe transportation services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible timing options. Convenient booking options allow hassle-free airport Urbania reservations."
  },
  {
    name: "Force Urbania on Rent in Pimpri Chinchwad",
    description: "Force Urbania on rent in Pimpri Chinchwad service offers dependable premium transportation for airport transfers, office outings, family functions, educational tours, and outstation travel from Pimpri Chinchwad Pune. Spacious luxury interiors ensure comfortable travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Force Urbania on Rent in Magarpatta City",
    description: "Force Urbania on rent in Magarpatta City service provides stylish transportation for IT professionals, airport transfers, business travel, family vacations, and local or outstation journeys from Magarpatta Pune. Spacious seating and elegant interiors ensure smooth travel experiences suitable for corporate and family passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, residential societies, hotels, and commercial locations across Magarpatta City Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Force Urbania on Rent in Hinjewadi",
    description: "Force Urbania on rent in Hinjewadi service offers premium transportation for IT employee travel, corporate events, sightseeing trips, airport transfers, and outstation journeys. Spacious seating and luxury interiors ensure comfortable travel experiences suitable for business teams and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, homes, offices, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Force Urbania for Wedding in Pune",
    description: "Force Urbania for wedding in Pune service provides luxurious transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious luxury seating and elegant interiors ensure smooth travel experiences suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "Force Urbania for Corporate Travel Pune",
    description: "Force Urbania for corporate travel Pune service offers professional premium transportation for business meetings, conferences, employee travel, industrial visits, and executive journeys. Spacious interiors and smooth travel performance ensure comfortable experiences suitable for office teams and corporate passengers. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate Urbania reservations."
  },
  {
    name: "Force Urbania for Family Trip Pune",
    description: "Force Urbania for family trip Pune service provides comfortable premium transportation for holiday vacations, sightseeing journeys, pilgrimage travel, and group tours with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "Force Urbania for Group Tour Pune",
    description: "Force Urbania for group tour Pune service offers spacious premium transportation for educational trips, tourist travel, sightseeing journeys, office outings, and pilgrimage tours. Comfortable luxury interiors ensure pleasant travel experiences suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group tour Urbania reservations."
  },
  {
    name: "Force Urbania for Airport Pickup Pune",
    description: "Force Urbania for airport pickup Pune service provides dependable premium transportation for tourists, business travelers, wedding groups, and family passengers arriving at airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport Urbania reservations."
  },
  {
    name: "Force Urbania for Outstation Travel Pune",
    description: "Force Urbania for outstation travel Pune service offers premium long-distance transportation for Goa tours, Konkan Darshan, Mahabaleshwar trips, pilgrimage journeys, and tourist travel from Pune. Spacious luxury interiors and smooth highway performance ensure comfortable travel experiences suitable for families and business groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  }
],

tableData: [
  ["Force Urbania Luxury Mini Bus on Rent Hadapsar", "13 Seater Urbania Bus Hire in Kharadi"],
  ["17 Seater Urbania Bus Hire in Kharadi", "Luxury Bus for Corporate Events Online Booking"],
  ["Pune Airport Urbania Bus on Rent", "Pune to Mumbai Airport Urbania Bus on Rent"],
  ["Force Urbania Luxury Mini Bus on Rent for Outstation", "Urbania Bus Hire in Hinjewadi"],
  ["Urbania Bus Hire in Aundh Baner", "Urbania Bus on Rent for Pune to Shirdi Darshan"],
  ["Force Urbania on Rent in Pune Airport", "Force Urbania on Rent in Pimpri Chinchwad"],
  ["Force Urbania on Rent in Magarpatta City", "Force Urbania on Rent in Hinjewadi"],
  ["Force Urbania for Wedding in Pune", "Force Urbania for Corporate Travel Pune"],
  ["Force Urbania for Family Trip Pune", "Force Urbania for Group Tour Pune"],
  ["Force Urbania for Airport Pickup Pune", "Force Urbania for Outstation Travel Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Force Urbania Luxury Mini Bus On Rent",
        WhyChoosedescription: "Aaradhya Travels provides reliable Force Urbania luxury mini bus rental service with premium vehicles, professional drivers, and smooth travel arrangements for corporate tours, weddings, family trips, and luxury group travel."
      },
      {
        WhyChooseheading: "Affordable Luxury Urbania Mini Bus Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Force Urbania luxury mini bus rental packages with transparent pricing, flexible booking plans, and premium travel facilities without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Luxury Mini Bus Booking Service",
        WhyChoosedescription: "Our Force Urbania luxury mini bus rental service operates 24 hours for airport transfers, VIP travel, wedding transportation, outstation tours, corporate events, and family vacations."
      },
      {
        WhyChooseheading: "Premium & Fully AC Urbania Mini Buses",
        WhyChoosedescription: "All Force Urbania luxury mini buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and equipped with premium seating for comfortable and luxurious travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Luxury Travel Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and luxury group travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Perfect for Corporate & Family Group Travel",
        WhyChoosedescription: "Force Urbania luxury mini buses are ideal for corporate teams, wedding guest transportation, VIP guests, tourist groups, family vacations, and premium outstation journeys."
      },
      {
        WhyChooseheading: "Doorstep Pickup & Drop Service",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup and drop services from airports, railway stations, hotels, homes, offices, and major city locations for hassle-free luxury travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Luxury Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation luxury transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Force Urbania luxury mini bus on rent?", answer: "Force Urbania luxury mini bus rental service provides premium group transportation for corporate travel, weddings, family tours, and outstation journeys." },
    { question: "Is Force Urbania luxury mini bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 Force Urbania luxury mini bus rental service." },
    { question: "Can I book Force Urbania luxury mini bus for outstation travel?", answer: "Yes, customers can book Force Urbania luxury mini buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide Force Urbania luxury mini buses for corporate events?", answer: "Yes, Aaradhya Travels provides Force Urbania luxury mini bus rental service for corporate meetings, office outings, conferences, and VIP employee transportation." },
    { question: "Are all Force Urbania luxury mini buses air-conditioned?", answer: "Yes, all Force Urbania luxury mini buses are fully air-conditioned and maintained for comfortable premium travel." },
    { question: "Can I book Force Urbania luxury mini bus online?", answer: "Yes, customers can easily book Force Urbania luxury mini bus rental service online or through phone booking." },
    { question: "Do you provide Force Urbania luxury mini buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Force Urbania luxury mini buses suitable for weddings, family vacations, and group tours." },
    { question: "Are Force Urbania luxury mini bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Force Urbania luxury mini bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from airports and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from airports, railway stations, hotels, and major city locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Jadhav",
    feedback:
      "We booked a Force Urbania luxury mini bus on rent for our outstation trip and the experience felt truly premium. The interiors were stylish, seating was extremely comfortable, and the ride was very smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback:
      "Force Urbania luxury mini bus rental made our group travel very comfortable and stress-free. The vehicle was well-maintained, spacious, and perfect for a relaxed journey with family.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania Luxury Mini Bus On Rent",
  "image": "https://www.aaradhyatravels99.com/assets/images/force-urbania-luxury-mini-bus-on-rent.jpg",
  "description": "Book Force Urbania Luxury Mini Bus on rent in Pune with Aaradhya Travels for premium group travel, corporate tours, weddings, airport transfers, and outstation trips. Available in 13 and 17 seater Urbania options across Hadapsar, Kharadi, and Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2187"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/force-urbania-luxury-mini-bus-on-rent"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Force Urbania Luxury Mini Bus On Rent in Pune | 13 & 17 Seater Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Force Urbania Luxury Mini Bus on rent in Pune with Aaradhya Travels. Premium 13 and 17 seater Urbania available for corporate travel, weddings, airport transfers, outstation tours, and luxury group trips across Pune."
  />

  <meta
    name="keywords"
    content="Force Urbania luxury mini bus on rent Hadapsar, 13 Seater Urbania Bus Hire in Kharadi, 17 Seater Urbania Bus Hire in Kharadi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbanialuxuryminibusonrent;